import { FC } from "react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useAtom } from "jotai";
// Required for localization.
import "dayjs/locale/it";
import "dayjs/locale/en";
import { userPeriodFilter } from "../../../../state/company";
import PeriodSelector from "../../../common/PeriodSelector";

dayjs.extend(localizedFormat);

interface Props {
	hidden: boolean;
}

const CompanyFiscalSelector: FC<Props> = ({ hidden }) => {
	const [filter, setFilter] = useAtom(userPeriodFilter);
	if (hidden) return <></>;
	return <PeriodSelector filter={filter} setFilter={setFilter} variant="complex" />;
};

export default CompanyFiscalSelector;
